import React from "react";
import { AutocompleteAttribute } from "lib/types/fields";
import { ErrorType } from "lib/types/address";
import { BaseSelectField } from "@shopflo/ui/base-select-field";
import { WarningCircle } from "@phosphor-icons/react";

interface DropDownProps {
  label?: string;
  placeholder?: string;
  id: string;
  name: string;
  autoComplete?: AutocompleteAttribute;
  value?: string;
  required?: boolean;
  onChange?: (value: any) => void;
  onBlur?: (e: any) => void;
  onFocus?: (e: any) => void;
  customClass?: string;
  customContainerClass?: string;
  error?: ErrorType;
  disabled?: boolean;
  options?: Array<any>;
  optionKey?: string;
  optionValue?: string;
}

const DropDown: React.FC<DropDownProps> = ({
  label,
  placeholder,
  id,
  name,
  autoComplete,
  value = "",
  required = false,
  onChange,
  customClass,
  customContainerClass,
  error = { status: false, message: "", showAlert: true },
  disabled = false,
  options = [],
  optionKey = "key",
  optionValue = "value",
  onBlur,
  onFocus,
}) => {
  const formattedOptions = options.map((option) => ({
    value: option[optionKey],
    label: option[optionValue],
  }));

  return (
    <div id={`flo-field-${id}`} className={`flex w-full flex-col ${customContainerClass}`}>
      <BaseSelectField
        id={id}
        name={name}
        label={label}
        placeholder={placeholder}
        value={value}
        required={required}
        disabled={disabled}
        error={Boolean(error?.status)}
        options={formattedOptions}
        autoComplete={autoComplete}
        aria-label={placeholder}
        onChange={onChange}
        onFocus={onFocus}
        onBlur={onBlur}
        className={customClass}
      />
      {error?.status && Boolean(error?.message) && (
        <div className="mt-1.5 px-0.5 flex items-center gap-1">
          <WarningCircle className="-mt-[1px] h-3 w-3 shrink-0 text-ouch" weight="bold" />
          <label
            htmlFor={id}
            className="bg-transparent text-xs font-normal text-ouch transition-all peer-focus:hidden">
            {error.message}
          </label>
        </div>
      )}
    </div>
  );
};

export default DropDown;
